"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _index = require("../../../../index");

var _filteritem_styles = _interopRequireDefault(require("./filteritem_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// styles

/* ========== ~~~~~~~~~~ EXPORT :  MENU : FILTER : HOLDER : FILTER ITEM ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_filteritem_styles.default)(function (props) {
  var handleChange = function handleChange(value) {
    props.onSelect(props.name, value);
  };

  return _react.default.createElement("div", {
    className: "filteritem ".concat(props.id, " ").concat(props.classes.filteritem, " ").concat(props.name)
  }, _react.default.createElement("div", {
    className: "filteritem-title-div"
  }, _react.default.createElement("label", {
    className: "filteritem-title"
  }, _react.default.createElement(_index.Icon, {
    name: props.filter.icon
  }), props.filter.title)), _react.default.createElement(_index.SelectableList, {
    key: props.name,
    name: props.name,
    type: 'checkbox',
    selected: props.state,
    items: props.filter.items,
    handleChange: handleChange
  }));
});

exports.default = _default;